<template>
  <div style="width:100vw;height:100vh;">
   <router-view></router-view>
  </div>
</template>

<script>
export default {

}
</script>

<style>
*{
    padding: 0;
    margin: 0;
}
</style>